/**
 * Globaler „aktiver Standort" (Compound) der Session.
 *
 * Multi-Compound: Ein Kunde/Betreiber mit mehreren Standorten kann hier den
 * aktiven Compound wählen; die Listen (Fahrzeuge, Hof, Services, Schäden, …)
 * filtern dann auf diesen Standort. `null` = „Alle Standorte".
 *
 * Persistiert wie uiStore (localStorage, partialize).
 */
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface LocationState {
  /** null = Alle Standorte */
  activeLocationId: string | null;
  setActiveLocation: (id: string | null) => void;
  clearActiveLocation: () => void;
}

export const useLocationStore = create<LocationState>()(
  persist(
    (set) => ({
      activeLocationId: null,
      setActiveLocation: (id) => set({ activeLocationId: id }),
      clearActiveLocation: () => set({ activeLocationId: null }),
    }),
    {
      name: 'location-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ activeLocationId: state.activeLocationId }),
    },
  ),
);
